/* The Timer's "Also running: Alex since 23:52" line (owner request 2026-10-14): two switches, both On by default.
   - Personal (Settings → "Also running", owner / admins / bookkeeper: the roles that see the line): member_prefs.
     show_others_running, the person's own row only (RLS, migration 015). Follows them to every device.
   - Company (same card, owner and admins only): company_settings.show_also_running. Off hides the line for everyone,
     owner and admins included; the personal switches are then greyed out.
   A copy is kept on this device for the first paint and offline; the database's values win (loaded after sign-in, at
   catch-ups and on live updates of either table).
   SCOPE: this only hides a line on the screen. It does NOT change who may read active_timers: the database (RLS) still
   gives owner / admins / bookkeeper everyone's timers and members only their own, whatever these switches say. */
import * as db from './db.ts';

let mine = true, company = true, user: string | null = null, changes = 0;
const KEY = (u: string) => 'ot_also_' + u;
/** this person's own switch (what they picked, even while the company switch is Off) */
export const showMine = () => mine;
/** the company-wide switch */
export const companyOn = () => company;
/** whether the Timer shows the "Also running" line (also needs a role that may see other people's timers) */
export const showAlsoRunning = () => mine && company;

function keep() { if (user) try { localStorage.setItem(KEY(user), JSON.stringify({mine, company})); } catch { /* private mode */ } }
/** sign-in: the values remembered on this device for this login (On when none) */
export function cachedAlso(u: string) {
  user = u; mine = company = true;
  try { const j = JSON.parse(localStorage.getItem(KEY(u)) || 'null'); if (j) { mine = j.mine !== false; company = j.company !== false; } } catch { /* ignore */ }
}
/** sign-out: back to On, and the device copy for that login is forgotten */
export function forgetAlso(u?: string | null) {
  mine = company = true; user = null; changes++;
  try { if (u) localStorage.removeItem(KEY(u)); else Object.keys(localStorage).filter(k => k.startsWith('ot_also_')).forEach(k => localStorage.removeItem(k)); } catch { /* ignore */ }
}
/** the database's values (they win over the device copy). Returns true when something changed. Offline: throws, the copy stays. */
export async function loadAlso(meId: string): Promise<boolean> {
  const asked = changes, r = await db.alsoRunningPrefs(meId);
  if (changes !== asked) return false;   // a switch was flipped here meanwhile: that one wins
  const changed = r.mine !== mine || r.company !== company;
  mine = r.mine; company = r.company; keep();
  return changed;
}
/** flip this person's own switch (saved, read back) */
export async function saveMine(meId: string, on: boolean) {
  const back = await db.saveShowOthersRunning(meId, on);
  mine = back; changes++; keep();
}
/** flip the company switch (owner, admins; the database refuses anyone else) */
export async function saveCompany(on: boolean) {
  const back = await db.saveCompanyAlsoRunning(on);
  company = back; changes++; keep();
}
